import React from 'react';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';

interface Props {
	onDeleteClick: () => void;
}

const ManagerWorkplaceItemButtonsDelete = ({ onDeleteClick }: Props) => {
	return (
		<LinkButton
			onClick={onDeleteClick}
			theme={Theme.RED}
			title='base.shared.delete'
			firstUpper
		/>
	);
};

export default ManagerWorkplaceItemButtonsDelete;
